/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{spring as r}from"../../animation/generators/spring/index.js";import{calcGeneratorDuration as t,maxGeneratorDuration as e}from"../../animation/generators/utils/calc-duration.js";import{millisecondsToSeconds as n}from"../../utils/time-conversion.js";function i(i,o=100){const a=r({keyframes:[0,o],...i}),s=Math.min(t(a),e);return{type:"keyframes",ease:r=>a.next(s*r).value/o,duration:n(s)}}export{i as createGeneratorEasing};
//# sourceMappingURL=create-generator-easing.js.map
